export default "__VITE_ASSET__2d29eda1__"